import { GoogleLoginOptions } from './strategy';
import analytic from '@/scripts/libs/analytic';
import { makeAuthTrackerPayload } from './helpers';
import { loginApi } from '@/scripts/webcall/v3/login';

export const googleLoginStrategy = (options: GoogleLoginOptions): void => {
  const handleCredentialResponse = (response: any): void => {
    analytic.send({
      category: 'sign-in',
      action: 'google',
    });
    const currentUrl = new URL(window.location.href);
    const authTrackerParams = makeAuthTrackerPayload(options.authTracker);
    loginApi.google(undefined, undefined,
      {
        idToken: response.credential,
        intent: authTrackerParams.intent || '',
        screenName: authTrackerParams.screen_name || '',
        section: authTrackerParams.section || '',
        resourceUri: authTrackerParams.resource_uri || '',
        query: authTrackerParams.query || '',
      }).then((response) => {
      if (response.data.context === 'login') {
        currentUrl.searchParams.append('access_token', response.data.accessToken);
        window.location.href = currentUrl.href;
      } else if (response.data.context === 'registration') {
        window.location.href = `/registration_google?access_token=${response.data.accessToken}&origin=${currentUrl}`;
      }
    });
  };
  window.onload = (): void => {
    (window as any).google.accounts.id.initialize({
      // eslint-disable-next-line @typescript-eslint/camelcase
      client_id: '306209973734-7n9367usv4vin5911p8ahhdass0mpaia.apps.googleusercontent.com',
      callback: handleCredentialResponse,
    });
    (window as any).google.accounts.id.renderButton(
      document.getElementById('google-signin-btn'),
      { theme: 'outline', size: 'large', width: '230px' },
    );
  };
};
